import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-privacy-notice-dialog',
  standalone: true,
  templateUrl: './privacy-notice-dialog.component.html',
  styleUrls: ['./privacy-notice-dialog.component.scss']
})
export class PrivacyNoticeDialogComponent {
  constructor(private dialogRef: MatDialogRef<PrivacyNoticeDialogComponent>) {}

  onAccept() {
    this.dialogRef.close('accept');
  }

  onDecline() {
    this.dialogRef.close('decline');
  }
}
